var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      staticClass: "add_purchase_order",
      attrs: {
        visible: _vm.dialogVisible,
        "append-to-body": true,
        title: _vm.dialogTitle,
        width: "1280px",
        "modal-append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        { staticClass: "purchase-order" },
        [
          _vm.isEdit
            ? _c(
                "div",
                { staticClass: "base-info-readonly" },
                [
                  _c("div", { staticClass: "order-form" }, [
                    _vm._v(" 基础信息 "),
                  ]),
                  _vm.baseInfo.processInstanceId
                    ? _c(
                        "el-row",
                        {
                          staticClass: "info-row",
                          staticStyle: { "margin-left": "32px" },
                          attrs: { gutter: 20 },
                        },
                        [
                          _c("el-col", { attrs: { span: 6 } }, [
                            _c(
                              "div",
                              { staticClass: "info-item" },
                              [
                                _c("label", [_vm._v("采购申请单号：")]),
                                _c(
                                  "span",
                                  { staticClass: "application-no-text" },
                                  [
                                    _vm._v(
                                      _vm._s(_vm.baseInfo.applicationNo || "无")
                                    ),
                                  ]
                                ),
                                _c(
                                  "el-button",
                                  {
                                    attrs: {
                                      type: "primary",
                                      plain: "",
                                      size: "mini",
                                    },
                                    on: { click: _vm.showApprovalDetail },
                                  },
                                  [_vm._v("查看")]
                                ),
                              ],
                              1
                            ),
                          ]),
                          _c("el-col", { attrs: { span: 6 } }, [
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("采购申请人：")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.baseInfo.applicantName || "无")
                                ),
                              ]),
                            ]),
                          ]),
                          _c("el-col", { attrs: { span: 6 } }, [
                            _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("采购申请人所属部门：")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(
                                    _vm.baseInfo.applicantDepartmentName || "无"
                                  )
                                ),
                              ]),
                            ]),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "el-row",
                    {
                      staticClass: "info-row",
                      staticStyle: { "margin-left": "32px" },
                      attrs: { gutter: 20 },
                    },
                    [
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("label", [_vm._v("采购单号：")]),
                          _c("span", [
                            _vm._v(
                              _vm._s(_vm.baseInfo.purchaseOrderNo || "无")
                            ),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("label", [_vm._v("采购单状态：")]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.baseInfo.statusLabel || "无")),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("label", [_vm._v("创建人：")]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.baseInfo.createdByName || "无")),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _vm.baseInfo.purchaseType === 1
                          ? _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("紧急采购：")]),
                              _c("span", [
                                _vm._v(_vm._s(_vm.urgentFlag || "-")),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                    ],
                    1
                  ),
                  _c(
                    "el-row",
                    {
                      staticClass: "info-row",
                      staticStyle: { "margin-left": "32px" },
                      attrs: { gutter: 20 },
                    },
                    [
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("label", [
                            _vm._v(
                              _vm._s(
                                _vm.baseInfo.purchaseType === 1
                                  ? " 申请采购时间："
                                  : "创建时间："
                              )
                            ),
                          ]),
                          _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.baseInfo.purchaseType === 1
                                  ? _vm.baseInfo.applicationTime
                                  : _vm.baseInfo.createdTime
                              )
                            ),
                          ]),
                        ]),
                      ]),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _vm.baseInfo.purchaseType === 1
                          ? _c("div", { staticClass: "info-item" }, [
                              _c("label", [_vm._v("申请通过/采购单位时间：")]),
                              _c("span", [
                                _vm._v(
                                  _vm._s(_vm.baseInfo.createdTime || "无")
                                ),
                              ]),
                            ])
                          : _vm._e(),
                      ]),
                      _c("el-col", { attrs: { span: 6 } }, [
                        _c("div", { staticClass: "info-item" }, [
                          _c("label", [_vm._v("修改时间：")]),
                          _c("span", [
                            _vm._v(_vm._s(_vm.baseInfo.updatedTime || "无")),
                          ]),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _c(
            "el-form",
            {
              ref: "orderForm",
              attrs: {
                model: _vm.form,
                rules: _vm.rules,
                "label-width": "110px",
                "label-position": "right",
              },
            },
            [
              _vm.baseInfo.purchaseType === 2 || _vm.type === "add"
                ? [
                    _c("div", { staticClass: "order-form" }, [
                      _vm._v(" 供应商信息 "),
                    ]),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "供应商", prop: "supplierId" },
                              },
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "请选择",
                                      clearable: "",
                                      filterable: "",
                                      "popper-class": "supplier-select",
                                      disabled: _vm.isEffective,
                                    },
                                    model: {
                                      value: _vm.form.supplierId,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.form, "supplierId", $$v)
                                      },
                                      expression: "form.supplierId",
                                    },
                                  },
                                  _vm._l(
                                    _vm.supplierOptions,
                                    function (item, index) {
                                      return _c("el-option", {
                                        key: (item && item.id) || index,
                                        attrs: {
                                          label:
                                            (item && item.name) || "未知供应商",
                                          value: item && item.id,
                                        },
                                      })
                                    }
                                  ),
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "销货清单编号",
                                  prop: "salesInvoiceNo",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "12",
                                    clearable: "",
                                    placeholder: "请输入",
                                    disabled: _vm.isEffective,
                                  },
                                  model: {
                                    value: _vm.form.salesInvoiceNo,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "salesInvoiceNo", $$v)
                                    },
                                    expression: "form.salesInvoiceNo",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "业务员",
                                  prop: "supplierContactPerson",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "30",
                                    clearable: "",
                                    placeholder: "请输入",
                                    disabled: _vm.isEffective,
                                  },
                                  model: {
                                    value: _vm.form.supplierContactPerson,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "supplierContactPerson",
                                        $$v
                                      )
                                    },
                                    expression: "form.supplierContactPerson",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "业务员联系号码",
                                  prop: "supplierContactNumber",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "20",
                                    clearable: "",
                                    placeholder: "请输入",
                                    disabled: _vm.isEffective,
                                  },
                                  on: { input: _vm.handleInput },
                                  model: {
                                    value: _vm.form.supplierContactNumber,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "supplierContactNumber",
                                        $$v
                                      )
                                    },
                                    expression: "form.supplierContactNumber",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      { attrs: { gutter: 20 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: {
                                  label: "发货地址",
                                  prop: "supplierShippingAddress",
                                },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "100",
                                    clearable: "",
                                    placeholder: "请输入",
                                    disabled: _vm.isEffective,
                                  },
                                  model: {
                                    value: _vm.form.supplierShippingAddress,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "supplierShippingAddress",
                                        $$v
                                      )
                                    },
                                    expression: "form.supplierShippingAddress",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _c(
                          "el-col",
                          { attrs: { span: 6 } },
                          [
                            _c(
                              "el-form-item",
                              {
                                attrs: { label: "店铺名称", prop: "storeName" },
                              },
                              [
                                _c("el-input", {
                                  attrs: {
                                    maxlength: "32",
                                    clearable: "",
                                    placeholder: "请输入",
                                    disabled: _vm.isEffective,
                                  },
                                  model: {
                                    value: _vm.form.storeName,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "storeName", $$v)
                                    },
                                    expression: "form.storeName",
                                  },
                                }),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.baseInfo.purchaseType === 2 || _vm.type === "add"
                ? [
                    _c(
                      "div",
                      { staticClass: "order-form" },
                      [
                        _vm._v(" 商品信息 "),
                        !_vm.isEdit && !_vm.isEffective
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: { click: _vm.showGoodsSelector },
                              },
                              [_vm._v("添加商品")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-table",
                                  {
                                    staticClass: "goods-table",
                                    staticStyle: {
                                      width: "100%",
                                      "margin-top": "10px",
                                      "margin-left": "-70px",
                                    },
                                    attrs: {
                                      data: _vm.form.items,
                                      border: "",
                                      rules: _vm.tableRules.items,
                                      "summary-method": _vm.getSummaries,
                                      "show-summary": "",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        type: "index",
                                        label: "序号",
                                        width: "60",
                                        align: "center",
                                      },
                                    }),
                                    _c(
                                      "el-table-column",
                                      {
                                        attrs: {
                                          label: "商品名称",
                                          "min-width": "150",
                                          "class-name": "goods-name-cell",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "goods-name-text",
                                                    },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.goodsName ||
                                                            "-"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          766702640
                                        ),
                                      },
                                      [
                                        _c("template", { slot: "header" }, [
                                          _c(
                                            "span",
                                            { staticClass: "required-label" },
                                            [_vm._v("商品名称")]
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "商品图片",
                                        "min-width": "100",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                scope.row.productImageUrl
                                                  ? _c("img", {
                                                      staticStyle: {
                                                        "object-fit": "cover",
                                                      },
                                                      attrs: {
                                                        src: scope.row
                                                          .productImageUrl,
                                                        width: "50",
                                                        height: "50",
                                                      },
                                                    })
                                                  : _c("span", [_vm._v("-")]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        4128016288
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "商品编码",
                                        prop: "goodsNo",
                                        width: "120",
                                      },
                                    }),
                                    _c(
                                      "el-table-column",
                                      {
                                        attrs: {
                                          prop: "quantity",
                                          label: "采购数量",
                                          "min-width": "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c(
                                                    "el-form-item",
                                                    {
                                                      staticStyle: {
                                                        "margin-bottom": "0",
                                                      },
                                                      attrs: {
                                                        prop:
                                                          "items." +
                                                          scope.$index +
                                                          ".quantity",
                                                        rules:
                                                          _vm.tableRules
                                                            .quantity,
                                                      },
                                                    },
                                                    [
                                                      !_vm.isEdit &&
                                                      !_vm.isEffective
                                                        ? _c("el-input", {
                                                            attrs: {
                                                              placeholder:
                                                                "请输入",
                                                              maxlength: "16",
                                                            },
                                                            on: {
                                                              input: function (
                                                                $event
                                                              ) {
                                                                return _vm.calculateAmount(
                                                                  scope.$index
                                                                )
                                                              },
                                                              blur: function (
                                                                $event
                                                              ) {
                                                                return _vm.validateTableField(
                                                                  scope.$index,
                                                                  "quantity"
                                                                )
                                                              },
                                                            },
                                                            model: {
                                                              value:
                                                                scope.row
                                                                  .quantity,
                                                              callback:
                                                                function ($$v) {
                                                                  _vm.$set(
                                                                    scope.row,
                                                                    "quantity",
                                                                    _vm._n($$v)
                                                                  )
                                                                },
                                                              expression:
                                                                "scope.row.quantity",
                                                            },
                                                          })
                                                        : _c("span", [
                                                            _vm._v(
                                                              _vm._s(
                                                                scope.row
                                                                  .quantity || 0
                                                              )
                                                            ),
                                                          ]),
                                                    ],
                                                    1
                                                  ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          791357330
                                        ),
                                      },
                                      [
                                        _c("template", { slot: "header" }, [
                                          _c(
                                            "span",
                                            { staticClass: "required-label" },
                                            [_vm._v("采购数量")]
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "el-table-column",
                                      {
                                        attrs: {
                                          prop: "unitPrice",
                                          label: "采购单价",
                                          "min-width": "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _vm.baseInfo.purchaseType ===
                                                    2 || _vm.type === "add"
                                                    ? _c(
                                                        "el-form-item",
                                                        {
                                                          staticStyle: {
                                                            "margin-bottom":
                                                              "0",
                                                          },
                                                          attrs: {
                                                            prop:
                                                              "items." +
                                                              scope.$index +
                                                              ".unitPrice",
                                                            rules:
                                                              _vm.tableRules
                                                                .unitPrice,
                                                          },
                                                        },
                                                        [
                                                          !_vm.isEdit &&
                                                          !_vm.isEffective
                                                            ? _c("el-input", {
                                                                attrs: {
                                                                  placeholder:
                                                                    "请输入",
                                                                  maxlength:
                                                                    "16",
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleUnitPriceInput(
                                                                        scope.$index,
                                                                        $event
                                                                      )
                                                                    },
                                                                  blur: function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.validateTableField(
                                                                      scope.$index,
                                                                      "unitPrice"
                                                                    )
                                                                  },
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row
                                                                      .unitPrice,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope.row,
                                                                        "unitPrice",
                                                                        _vm._n(
                                                                          $$v
                                                                        )
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row.unitPrice",
                                                                },
                                                              })
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.formatCurrency(
                                                                      scope.row
                                                                        .unitPrice
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "div",
                                                        [
                                                          !_vm.isEdit &&
                                                          !_vm.isEffective
                                                            ? _c("el-input", {
                                                                attrs: {
                                                                  placeholder:
                                                                    "请输入",
                                                                  maxlength:
                                                                    "16",
                                                                },
                                                                on: {
                                                                  input:
                                                                    function (
                                                                      $event
                                                                    ) {
                                                                      return _vm.handleUnitPriceInput(
                                                                        scope.$index,
                                                                        $event
                                                                      )
                                                                    },
                                                                },
                                                                model: {
                                                                  value:
                                                                    scope.row
                                                                      .unitPrice,
                                                                  callback:
                                                                    function (
                                                                      $$v
                                                                    ) {
                                                                      _vm.$set(
                                                                        scope.row,
                                                                        "unitPrice",
                                                                        _vm._n(
                                                                          $$v
                                                                        )
                                                                      )
                                                                    },
                                                                  expression:
                                                                    "scope.row.unitPrice",
                                                                },
                                                              })
                                                            : _c("span", [
                                                                _vm._v(
                                                                  _vm._s(
                                                                    _vm.formatCurrency(
                                                                      scope.row
                                                                        .unitPrice
                                                                    )
                                                                  )
                                                                ),
                                                              ]),
                                                        ],
                                                        1
                                                      ),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          4023009116
                                        ),
                                      },
                                      [
                                        _c("template", { slot: "header" }, [
                                          _c(
                                            "span",
                                            { staticClass: "required-label" },
                                            [_vm._v("采购单价")]
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                    _c(
                                      "el-table-column",
                                      {
                                        attrs: {
                                          prop: "lineAmount",
                                          label: "金额(元)",
                                          "min-width": "120",
                                        },
                                        scopedSlots: _vm._u(
                                          [
                                            {
                                              key: "default",
                                              fn: function (scope) {
                                                return [
                                                  _c("el-input", {
                                                    attrs: {
                                                      value: _vm.formatCurrency(
                                                        scope.row.lineAmount
                                                      ),
                                                      disabled: true,
                                                    },
                                                  }),
                                                ]
                                              },
                                            },
                                          ],
                                          null,
                                          false,
                                          1787225703
                                        ),
                                      },
                                      [
                                        _c("template", { slot: "header" }, [
                                          _c(
                                            "span",
                                            { staticClass: "required-label" },
                                            [_vm._v("金额(元)")]
                                          ),
                                        ]),
                                      ],
                                      2
                                    ),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "商品备注",
                                        "min-width": "150",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                !_vm.isEdit && !_vm.isEffective
                                                  ? _c("el-input", {
                                                      attrs: {
                                                        placeholder: "请输入",
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.remarks,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "remarks",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.remarks",
                                                      },
                                                    })
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row.remarks ||
                                                            "-"
                                                        )
                                                      ),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2566558055
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "库存单位",
                                        prop: "unitOfMeasure",
                                        width: "80",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: { label: "品牌", width: "80" },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row.brandName || "-"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1633375180
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "可用库存",
                                        prop: "stock",
                                        width: "80",
                                      },
                                    }),
                                    !_vm.isEdit && !_vm.isEffective
                                      ? _c("el-table-column", {
                                          attrs: { label: "操作", width: "80" },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "default",
                                                fn: function (scope) {
                                                  return [
                                                    _c(
                                                      "el-button",
                                                      {
                                                        attrs: {
                                                          type: "text",
                                                          size: "mini",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.removeItem(
                                                              scope.$index
                                                            )
                                                          },
                                                        },
                                                      },
                                                      [_vm._v("删除")]
                                                    ),
                                                  ]
                                                },
                                              },
                                            ],
                                            null,
                                            false,
                                            1817185574
                                          ),
                                        })
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _vm.baseInfo.purchaseType === 1 ||
              (_vm.type === "add" && _vm.formData.purchaseType === 1)
                ? [
                    _c(
                      "div",
                      { staticClass: "order-form" },
                      [
                        _vm._v(" 商品信息 "),
                        !_vm.isEdit && !_vm.isEffective
                          ? _c(
                              "el-button",
                              {
                                attrs: { type: "text", size: "mini" },
                                on: { click: _vm.showGoodsSelector },
                              },
                              [_vm._v("添加商品")]
                            )
                          : _vm._e(),
                      ],
                      1
                    ),
                    _c(
                      "el-row",
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 24 } },
                          [
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-table",
                                  {
                                    staticStyle: {
                                      width: "100%",
                                      "margin-top": "10px",
                                      "margin-left": "-70px",
                                    },
                                    attrs: {
                                      data: _vm.form.items,
                                      border: "",
                                      "summary-method": _vm.getSummaries,
                                      "show-summary": "",
                                    },
                                  },
                                  [
                                    _c("el-table-column", {
                                      attrs: {
                                        type: "index",
                                        label: "序号",
                                        width: "60",
                                        align: "center",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "物品名称",
                                        "min-width": "100",
                                        "class-name": "goods-name-cell",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "goods-name-text",
                                                  },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        scope.row.goodsName ||
                                                          "-"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        766702640
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "规格",
                                        "min-width": "100",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.specification ||
                                                        "-"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        2763594582
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "单位",
                                        prop: "unitOfMeasure",
                                        width: "120",
                                      },
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "quantity",
                                        label: "采购数量",
                                        "min-width": "100",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      scope.row.quantity || 0
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        4169599309
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "estimatedUnitPrice",
                                        label: "估价",
                                        "min-width": "100",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatCurrency(
                                                        scope.row
                                                          .estimatedUnitPrice
                                                      ) || 0.0
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1619792836
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        prop: "lineAmount",
                                        label: "实际采购金额(元)",
                                        "min-width": "150",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                !_vm.isEffective
                                                  ? _c("el-input", {
                                                      attrs: {
                                                        placeholder: "请输入",
                                                        disabled:
                                                          _vm.isEffective,
                                                      },
                                                      on: {
                                                        input: function (
                                                          $event
                                                        ) {
                                                          return _vm.handleLineAmountInput(
                                                            scope.$index,
                                                            $event
                                                          )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          scope.row.lineAmount,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            scope.row,
                                                            "lineAmount",
                                                            $$v
                                                          )
                                                        },
                                                        expression:
                                                          "scope.row.lineAmount",
                                                      },
                                                    })
                                                  : _c("el-input", {
                                                      attrs: {
                                                        value:
                                                          _vm.formatCurrency(
                                                            scope.row.lineAmount
                                                          ),
                                                        disabled: true,
                                                      },
                                                    }),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        622361728
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "需求到货时间",
                                        "min-width": "180",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _c("span", [
                                                  _vm._v(
                                                    _vm._s(
                                                      _vm.formatDateTime(
                                                        scope.row
                                                          .requiredDeliveryTime
                                                      ) || "-"
                                                    )
                                                  ),
                                                ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        1926470216
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "供应商",
                                        prop: "supplierId",
                                        width: "120",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                !_vm.isEffective
                                                  ? _c(
                                                      "el-select",
                                                      {
                                                        attrs: {
                                                          placeholder: "请选择",
                                                          clearable: "",
                                                          filterable: "",
                                                          "popper-class":
                                                            "supplier-select",
                                                          disabled:
                                                            _vm.isEffective,
                                                        },
                                                        on: {
                                                          change: function (
                                                            $event
                                                          ) {
                                                            return _vm.handleSupplierChange(
                                                              scope.$index,
                                                              $event
                                                            )
                                                          },
                                                        },
                                                        model: {
                                                          value:
                                                            scope.row
                                                              .supplierId,
                                                          callback: function (
                                                            $$v
                                                          ) {
                                                            _vm.$set(
                                                              scope.row,
                                                              "supplierId",
                                                              $$v
                                                            )
                                                          },
                                                          expression:
                                                            "scope.row.supplierId",
                                                        },
                                                      },
                                                      _vm._l(
                                                        _vm.supplierOptions,
                                                        function (item, index) {
                                                          return _c(
                                                            "el-option",
                                                            {
                                                              key:
                                                                (item &&
                                                                  item.id) ||
                                                                index,
                                                              attrs: {
                                                                label:
                                                                  (item &&
                                                                    item.name) ||
                                                                  "未知供应商",
                                                                value:
                                                                  (item &&
                                                                    item.id) ||
                                                                  "",
                                                              },
                                                            }
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    )
                                                  : _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          scope.row
                                                            .supplierName || "-"
                                                        )
                                                      ),
                                                    ]),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        498478801
                                      ),
                                    }),
                                    _c("el-table-column", {
                                      attrs: {
                                        label: "图片特殊备注",
                                        width: "120",
                                      },
                                      scopedSlots: _vm._u(
                                        [
                                          {
                                            key: "default",
                                            fn: function (scope) {
                                              return [
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      scope.row
                                                        .imageSpecialNotes ||
                                                        "-"
                                                    ) +
                                                    " "
                                                ),
                                              ]
                                            },
                                          },
                                        ],
                                        null,
                                        false,
                                        270176629
                                      ),
                                    }),
                                  ],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ]
                : _vm._e(),
              _c("div", { staticClass: "order-form" }, [_vm._v(" 采购信息 ")]),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "采购员", prop: "purchaserId" } },
                        [
                          _c(
                            "el-select",
                            {
                              ref: "purchaserSelect",
                              attrs: {
                                placeholder: "请选择",
                                clearable: "",
                                "popper-class": "supplier-select",
                                disabled: _vm.isEffective,
                              },
                              on: {
                                focus: _vm.openUserPicker,
                                "visible-change":
                                  _vm.handlePurchaserSelectVisible,
                              },
                              model: {
                                value: _vm.form.purchaserId,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "purchaserId", $$v)
                                },
                                expression: "form.purchaserId",
                              },
                            },
                            [
                              _vm.form.purchaserId && _vm.form.purchaserName
                                ? _c("el-option", {
                                    key: _vm.form.purchaserId,
                                    attrs: {
                                      label: _vm.form.purchaserName,
                                      value: _vm.form.purchaserId,
                                    },
                                  })
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "运费", prop: "freightCost" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "16",
                              placeholder: "请输入",
                              disabled: _vm.isEffective,
                            },
                            on: { input: _vm.handleFreightCostInput },
                            model: {
                              value: _vm.form.freightCost,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "freightCost", $$v)
                              },
                              expression: "form.freightCost",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "优惠金额", prop: "discountAmount" },
                        },
                        [
                          _c("el-input", {
                            attrs: { placeholder: "自动计算", disabled: true },
                            model: {
                              value: _vm.form.discountAmount,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "discountAmount", $$v)
                              },
                              expression: "form.discountAmount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "采购总金额", prop: "finalAmount" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "16",
                              placeholder: "请输入",
                              disabled: _vm.isEffective,
                            },
                            on: { input: _vm.handleFinalAmountInput },
                            model: {
                              value: _vm.form.finalAmount,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "finalAmount", $$v)
                              },
                              expression: "form.finalAmount",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: { label: "收货地址", prop: "shippingAddress" },
                        },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "64",
                              placeholder: "请输入",
                              disabled: _vm.isEffective,
                            },
                            model: {
                              value: _vm.form.shippingAddress,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "shippingAddress", $$v)
                              },
                              expression: "form.shippingAddress",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-col",
                    { attrs: { span: 12 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "采购单备注", prop: "remarks" } },
                        [
                          _c("el-input", {
                            attrs: {
                              maxlength: "64",
                              placeholder: "请输入",
                              disabled: _vm.isEffective,
                            },
                            model: {
                              value: _vm.form.remarks,
                              callback: function ($$v) {
                                _vm.$set(_vm.form, "remarks", $$v)
                              },
                              expression: "form.remarks",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                { attrs: { gutter: 20 } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c(
                        "el-form-item",
                        { attrs: { label: "附件", prop: "attachmentUrl" } },
                        [
                          _vm.fileList.length === 0
                            ? _c(
                                "el-upload",
                                {
                                  ref: "upload",
                                  attrs: {
                                    accept: "*",
                                    drag: "",
                                    action: "#",
                                    multiple: false,
                                    "http-request": _vm.orderImportLive,
                                    limit: 1,
                                    "before-upload": _vm.beforeUpload,
                                    "file-list": _vm.fileList,
                                  },
                                },
                                [
                                  _c(
                                    "el-button",
                                    {
                                      attrs: {
                                        type: "primary",
                                        plain: "",
                                        size: "mini",
                                      },
                                    },
                                    [_vm._v("点击上传")]
                                  ),
                                ],
                                1
                              )
                            : _c("div", { staticClass: "file-list" }, [
                                _c(
                                  "div",
                                  { staticClass: "file-item" },
                                  [
                                    _c("i", {
                                      staticClass: "el-icon-document",
                                    }),
                                    _c("span", { staticClass: "file-name" }, [
                                      _vm._v(
                                        _vm._s(
                                          (_vm.fileList[0] &&
                                            _vm.fileList[0].name) ||
                                            "附件"
                                        )
                                      ),
                                    ]),
                                    !_vm.isEffective
                                      ? _c(
                                          "el-button",
                                          {
                                            attrs: {
                                              type: "text",
                                              size: "mini",
                                            },
                                            on: { click: _vm.handleRemove },
                                          },
                                          [_vm._v("删除")]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "upload-tips" }, [
                            _vm._v(" (大小限制在4M以内，格式不限) "),
                          ]),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            2
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          (_vm.type === "add" || (_vm.isEdit && _vm.baseInfo.status === 0)) &&
          !_vm.isEffective
            ? _c(
                "el-button",
                {
                  attrs: { size: "mini", type: "primary" },
                  on: { click: _vm.confirmEffect },
                },
                [_vm._v(" 确认生效 ")]
              )
            : _vm._e(),
          !_vm.isEffective
            ? _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.saveForm } },
                [_vm._v("保存")]
              )
            : _vm._e(),
          _c(
            "el-button",
            {
              attrs: { size: "mini" },
              on: {
                click: function ($event) {
                  _vm.dialogVisible = false
                },
              },
            },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
      _c("org-picker", {
        ref: "orgPicker",
        attrs: { title: "选择采购员", multiple: false },
        on: { ok: _vm.selectedPurchaser },
      }),
      _c("GoodsSelector", {
        ref: "goodsSelector",
        on: { selected: _vm.addSelectedGoods },
      }),
      _c("pop-process", { ref: "popProcess" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }